import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Artificial Intelligence`,
  heading: `Turn every customer interaction into a unique customer experience`,
  description: `Segment makes it easier than ever to understand, predict, and generate 1:1 customer engagement in real time and at scale.`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline variant="h5" tag="p">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="p">
              {copy.description}
            </CopyText.Description>
            <HeroRecipe.Form>
              <DemoForm
                isProgressive={true}
                customFormIdentifier="site-customerai-demo"
                customTrackingType="site-customerai-demo"
                successMessageAppearance="twilioLight"
              />
            </HeroRecipe.Form>
          </CopyTextBase>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="827" height="810" src={heroPng2x} alt="" loading="lazy" />
          </picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
